import {
  Component,
  OnInit,
  SimpleChange,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  EventEmitter
} from "@angular/core";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"]
})
export class LoadingComponent implements OnInit, OnChanges {
  @Input("error") error: any = false;
  @Output("reload") load: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.error.currentValue && !changes.error.currentValue.ok) {
      if (sessionStorage.getItem("attempts")) {
        if (Number(sessionStorage.getItem("attempts")) >= 10) {
          console.warn("Más de 10 intentos de recarga");
          sessionStorage.setItem("attempts", "0");
        } else {
          sessionStorage.setItem(
            "attempts",
            JSON.stringify(Number(sessionStorage.getItem("attempts")) + 1)
          );
        }
      } else {
        sessionStorage.setItem("attempts", "0");
      }
    }
  }

  reload() {
    this.error = false;
    this.load.emit(true);
  }
}
